import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import seo from "@/seo/pages.json";

export default function HomeFaq() {
  const [open, setOpen] = useState(0);
  return (
    <section className="relative py-24 md:py-32 border-t border-white/5" data-testid="home-faq">
      <div className="max-w-4xl mx-auto px-6 md:px-10">
        <Reveal>
          <div className="eyebrow mb-5">FAQ</div>
          <h2 className="font-serif-display text-4xl md:text-6xl leading-[1.05]">
            Questions founders ask <em className="gold-shine font-medium not-italic">before they hire us</em>.
          </h2>
        </Reveal>
        <div className="mt-12 divide-y divide-[#E4E4E7] border-y border-white/10">
          {seo.faq.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={f.q} data-testid={`home-faq-item-${i}`}>
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  aria-expanded={isOpen}
                  className="w-full flex items-start justify-between gap-6 py-6 text-left"
                  data-testid={`home-faq-toggle-${i}`}
                >
                  <h3 className="font-serif-display text-xl md:text-2xl leading-snug">{f.q}</h3>
                  <span className="mt-1 text-red-500 flex-shrink-0">{isOpen ? <Minus size={18} /> : <Plus size={18} />}</span>
                </button>
                <div className={`grid transition-[grid-template-rows] duration-300 ${isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"}`}>
                  <p className="overflow-hidden text-zinc-400 font-body leading-relaxed pr-10">
                    <span className="block pb-6">{f.a}</span>
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
